import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {Alert, Button, Dropdown, Empty, Icon, message, Popconfirm, Spin, Table, Menu, Input, Col, Row, Tag} from 'antd';
import './contacts.scss';
import { Switch } from 'antd';
import AnimateEnter from '../AnimateEnter';
import { bindActionCreators } from 'redux';
import { setContactsCount } from '../../actions/Actions';
import { CONTACTS_RESOURCE_NAME } from '../../config/constants';
import { _callResource } from '../../context/_callResource';
import { allContactsColumns } from './columns/allContactsColumns';
import { ApiError } from '../../utils/errors';
import { withCancellablePromise } from '../../hocs/withCancellablePromise';
import { grammarNumbers, makeMsisdnBeautiful } from '../../Utils';
import MESSAGES from "../../locale/messages";
import TEXTS from "../../locale/texts";

class AllContacts extends Component {
  state = {
    contacts: [],
    isLoading: true,
    showBlackList: false,
    selectedRows: [],
    isDeleteLoading: false,
    pageSize: 20,
    currentPage: 1,
    isMounted: true,
    filter: '',

    // contacts resource
    contactsData: [],
    contactsDataIsLoading: true,
    contactsDataError: null,

    // contacts delete resource
    contactsDeleteIsLoading: false,
    contactsDeleteError: false,

    // contacts export resource
    contactsExportIsLoading: false,
    contactsExportError: false,

    blacklistContactsIsLoading: false,
    blacklistContactsError: null,
  };

  callResource = _callResource.bind(this);
  columns = allContactsColumns.bind(this);

  onDelete = () => {
    const { promiseCancelToken, addNotification, lang } = this.props;
    const { selectedRows } = this.state;
    const ids = selectedRows.map(({ id }) => id);
    const n = ids.length;
    this.callResource({
      resourceName: CONTACTS_RESOURCE_NAME,
      apiClassName: 'contacts',
      action: 'delete',
      apiCallParams: { ids },
      promiseCancelToken,
      onSuccess: () => {
        this.setState({ selectedRows: [] });
        addNotification(MESSAGES.contactsAreDeleted(n)[lang]);
        this.getAllContactsData();
      },
      onError: (err) => {
        const { errorMessage } = new ApiError(err);
        message.error(`${MESSAGES.couldNotDeleteContact(n)[lang]}: ${errorMessage}.`, 5);
      }
    });
  };

  getAllContactsData = () => {
    const { promiseCancelToken } = this.props;
    this.setState({ selectedRows: [] });
    this.callResource({
      resourceName: CONTACTS_RESOURCE_NAME,
      apiClassName: 'contacts',
      action: 'get',
      promiseCancelToken,
      onSuccess: ({ data: { items: contacts } }) => {
        if (contacts && contacts.length > 0) {
          this.props.setContactsCount(contacts.length);
        }
      }
    });
  };

  componentDidMount() {
   this.getAllContactsData();
  };

  createContact = () => {
    this.props.history.push('/phonebook/contacts/create');
  };

  importContact = () => {
    this.props.history.push('/phonebook/contacts/import');
  };
  exportContact = () => {
    const ids = this.state.selectedRows.map(({ id }) => id);
    const count = ids.length;
    const { promiseCancelToken, lang } = this.props;
    this.callResource({
      resourceName: CONTACTS_RESOURCE_NAME,
      apiClassName: 'contacts',
      action: 'download',
      apiCallParams: { ids },
      promiseCancelToken,
      notification: {
       text: MESSAGES.contactsAreExported(count)[lang]
      }
    });
  };

  onShowBlackList = (checked) => {
    this.setState({
      showBlackList: checked,
      selectedRows: []
    });
  };

  selectOption = (name) => {
    console.log(`selectedOption: ${name}`);
  };

  handleChangeFilter = ({ target: { value: filter } }) => {
    this.setState({ filter });
  };

  resetSearch = () => {
    this.setState({ filter: '' });
  };

  onBlackList = ({ key: addOrRemove }) => {
    const { promiseCancelToken, addNotification, lang } = this.props;
    const { selectedRows } = this.state;
    const ids = selectedRows.map(({ id }) => id);
    const n = ids.length;
    this.callResource({
      resourceName: CONTACTS_RESOURCE_NAME,
      apiClassName: 'contacts',
      action: 'blacklist',
      apiCallParams: { ids, addOrRemove },
      promiseCancelToken,
      onSuccess: () => {
        const msg = addOrRemove === 'add'
          ? MESSAGES.contactsAreAddedToBlackList(n)[lang]
          : MESSAGES.contactsAreRemovedFromBlackList(n)[lang];
        addNotification(msg);
        this.getAllContactsData();
      },
      onError: (err) => {
        const { errorMessage } = new ApiError(err);
        const msg = (() => {
          switch(addOrRemove) {
            case 'add':
              if (n === 1) {
                return TEXTS.couldNotAddOneContactToBlackList[lang];
              } else {
                return TEXTS.couldNotAddManyContactsToBlackList[lang];
              }
            case 'remove':
              if (n === 1) {
                return TEXTS.couldNotRemoveOneContactFromBlackList[lang];
              } else {
                return TEXTS.couldNotRemoveManyContactsToBlackList[lang];
              }
            default:
              return '';
          }
        })();
        message.error(`${msg}: ${errorMessage}.`, 5);
      }
    });
  };

  renderData = () => {
    const {
      contactsData,
      showBlackList,
      pageSize,
      isMounted,
      filter,
      contactsDataError,
      selectedRows
    } = this.state;
    const {lang} = this.props;

    if (contactsDataError) {
      const { errorTitle, errorMessage } = contactsDataError;
      return (
        <Alert
          message={errorTitle}
          description={errorMessage}
          type="error"
        />
      );
    }

    const contacts = contactsData ? contactsData.items : [];
    const columns = this.columns(lang);

    let finalContacts = contacts && contacts.filter(({ inBlackList }) => {
      return showBlackList ? inBlackList : !inBlackList;
    });

    finalContacts = !!(finalContacts && filter) ? finalContacts.filter(({ msisdn, groups, firstname }) => {
      const matcher = new RegExp(`${filter}`, 'ig');
      return msisdn.match(matcher) || (groups && groups.match(matcher)) || (firstname && firstname.match(matcher));
    }) : finalContacts;

    return (
      <AnimateEnter
        paginationAnimate={{ isMounted }}
      >
        <Table
          columns={columns}
          dataSource={finalContacts}
          rowSelection={{
            onChange: (_, selectedRows) => {
              this.setState({ selectedRows });
            },
            selectedRowKeys: selectedRows.map(({ id }) => id)
          }}
          rowKey={({ id }) => id}
          pagination={{
            pageSize: pageSize,
            hideOnSinglePage: true,
            size: 'large',
            onChange: (page) => {
              window.scrollTo(0 ,172);
              this.setState({
                currentPage: page,
                isMounted: false
              });
              setTimeout(() => {
                this.setState({ isMounted: true });
              }, 0);
            }
          }}
        />
      </AnimateEnter>
    )
  };

  renderMenu = () => {
    const { showBlackList, blacklistContactsIsLoading } = this.state;
    const { lang } = this.props;
    return (
      <Menu
        onClick={this.onBlackList}
      >
        {showBlackList
          ? <Menu.Item key="remove">
              <Icon type="minus" style={{position: 'relative', top: -3}} />
              {TEXTS.btnBlackListRemove[lang]}
            {blacklistContactsIsLoading && <Icon type="loading" />}
          </Menu.Item>
        : <Menu.Item key="add">
            <Icon type="plus" style={{position: 'relative', top: -3}} />
            {TEXTS.btnBlackListAdd[lang]}
            {blacklistContactsIsLoading && <Icon type="loading" />}
          </Menu.Item>}
      </Menu>
    );
  };

  render() {
    const { lang } = this.props;
    const {
      contactsData,
      contactsDataIsLoading,
      selectedRows,
      contactsDeleteIsLoading,
      contactsExportIsLoading,
      filter,
      blacklistContactsIsLoading
    } = this.state;
    return (
      <div>
        <section className="submenu all-contacts bg-white table-header">
          <Row gutter={16} className="mb-4">
            <Col xs={24} sm={24} md={8} lg={8} xl={5} xxl={4}>
              <Button
                  block
                  className="mr-3"
                  size="large"
                  icon="user-add"
                  onClick={this.createContact}
              >
                {TEXTS.btnCreateContact[lang]}
              </Button>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={5} xxl={4}>
              <Button
                  block
                  className="mr-3"
                  size="large"
                  icon="import"
                  onClick={this.importContact}
              >
                {TEXTS.btnImportContacts[lang]}
              </Button>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={5} xxl={4}>
              <Popconfirm
                  placement="bottom"
                  title={
                    <span style={{display: 'block', maxWidth: 400}}>
                      {TEXTS.areYouSureToDeleteChosenContacts[lang]}?
                    </span>}
                  okText={TEXTS.yes[lang]}
                  cancelText={TEXTS.btnToCancel[lang]}
                  onConfirm={this.onDelete}
                  disabled={selectedRows.length === 0 || contactsDeleteIsLoading}
              >
                <Button
                    block
                    ghost={selectedRows.length > 0 && !contactsDeleteIsLoading}
                    size="large"
                    icon="user-delete"
                    type="danger"
                    loading={contactsDeleteIsLoading}
                    disabled={selectedRows.length === 0 || contactsDeleteIsLoading}
                >
                  {TEXTS.btnDeleteContacts[lang]}
                </Button>
              </Popconfirm>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={5} xxl={4}>
              <Button
                block
                size="large"
                type="default"
                icon='export'
                loading={contactsExportIsLoading}
                disabled={selectedRows.length === 0 || contactsExportIsLoading}
                onClick={this.exportContact}
              >
                {TEXTS.btnExportContacts[lang]}
              </Button>
            </Col>
          </Row>

          <div className="all-contacts-options">
            <div className="d-flex">
              <div className="d-flex align-items-center mr-4">
                <label className="mr-2" style={{fontSize: '14px', marginBottom: '0.2rem'}}>
                  {TEXTS.toggleShowBlackList[lang]}
                </label>
                <Switch onChange={this.onShowBlackList} />
              </div>
              <Dropdown
                overlay={this.renderMenu}
                disabled={selectedRows.length === 0 || blacklistContactsIsLoading}
              >
                <Button
                  className="mb-0"
                  size="large"
                  icon="stop"
                  loading={blacklistContactsIsLoading}
                  disabled={blacklistContactsIsLoading}
                >
                  {TEXTS.btnBlackList[lang]} <Icon type="down" />
                </Button>
              </Dropdown>
            </div>

            <Col xs={24} sm={24} md={5} lg={6} xl={7} xxl={7} className="search">
              <Input
                prefix={<Icon type="search" style={{ color: 'rgba(0,0,0,.25)' }} />}
                allowClear
                size="large"
                value={filter}
                placeholder={TEXTS.searchContactsPlaceholder[lang]}
                onChange={this.handleChangeFilter}
              />
            </Col>
            {contactsData.items ?
              <div style={{color: '#4f226d', marginBottom: '0.2rem', fontSize: '16px'}}>
                {TEXTS.totalContacts[lang]}: <Tag color="purple" style={{fontSize: '16px', marginRight: '0'}}>{contactsData.items.length}</Tag>
              </div> : <div/>
            }
          </div>
        </section>
        <section className="all-campaigns">
          {contactsDataIsLoading
            ? <Empty description={TEXTS.dataIsLoading[lang]}>
                <div style={{marginTop: 15, textAlign: 'center'}}>
                  <Spin spinning={true} />
                </div>
              </Empty>
            : this.renderData()}
        </section>
      </div>
    )
  }
}

export default withCancellablePromise(
  connect(null, dispatch => ({
    setContactsCount: bindActionCreators(setContactsCount, dispatch),
}))(withRouter(AllContacts)), 'getContacts');
